// extracted by mini-css-extract-plugin
module.exports = {"chevron":"styles_chevron__ly939","chevronTrigger":"styles_chevronTrigger__wft2M"};